import CloseIcon from "@mui/icons-material/Close";
import InstagramIcon from "@mui/icons-material/Instagram";
import MailIcon from "@mui/icons-material/Mail";
import MenuIcon from "@mui/icons-material/Menu";
import AppBar from "@mui/material/AppBar";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import CssBaseline from "@mui/material/CssBaseline";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import GlobalStyles from "@mui/material/GlobalStyles";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Paper from "@mui/material/Paper";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import * as React from "react";
import { useEffect } from "react";
import course1 from "./img/course_1.jpg";
import course2 from "./img/course_2.jpg";
import course3 from "./img/course_3.jpg";
import course4 from "./img/course_4.jpg";
import graceFC from "./img/grace-f-c.JPG";
import homeLarge from "./img/home_large.jpg";
import homeSmall1 from "./img/home_small1.JPG";
import homeSmall2 from "./img/home_small2.JPG";
import homeSmall3 from "./img/home_small3.JPG";
import homelessonArtflower from "./img/homelesson_artflower.jpg";
import homelessonBouquet from "./img/homelesson_bouquet.jpg";
import homelessonDriedflower from "./img/homelesson_driedflower.jpg";
import homelessonFreshflower from "./img/homelesson_freshflower.jpg";
import homelessonHerbarium from "./img/homelesson_herbarium.jpg";
import homelessonPreservedflower from "./img/homelesson_preservedflower.jpg";
import logoTop from "./img/logo_top.PNG";
import onsitelesson1 from "./img/onsitelesson_1.jpg";
import onsitelesson2 from "./img/onsitelesson_2.jpg";
import onsitelesson3 from "./img/onsitelesson_3.jpg";
import onsitelesson4 from "./img/onsitelesson_4.jpg";
import profileImg from "./img/profile.jpg";
import { supabase } from "./supabaseClient";

const drawerWidth = 240;
const navItems = [
  "Home",
  "Information",
  "プロフィール",
  "自宅レッスン",
  "出張レッスン",
  "Instagram",
  "お問い合わせ",
];

const theme = createTheme({
  palette: {
    mode: "light",
    primary: { main: "#7b8f6a" },
    secondary: { main: "#e3a7c0" },
    background: { default: "#f6f1e9", paper: "#fffaf4" },
    text: { primary: "#2f2a25", secondary: "#5a5147" },
  },
  typography: {
    fontFamily:
      '"Noto Sans JP", "Hiragino Kaku Gothic ProN", "Meiryo", sans-serif',
    h4: {
      fontFamily: '"Cormorant Garamond", "Noto Serif JP", serif',
      fontWeight: 600,
      letterSpacing: "0.08em",
    },
    h5: {
      fontFamily: '"Cormorant Garamond", "Noto Serif JP", serif',
      fontWeight: 600,
      letterSpacing: "0.06em",
    },
    h6: {
      fontFamily: '"Cormorant Garamond", "Noto Serif JP", serif',
      fontWeight: 600,
      letterSpacing: "0.04em",
    },
    body1: {
      lineHeight: 1.9,
    },
  },
  shape: { borderRadius: 12 },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: "rgba(247, 241, 233, 0.78)",
          color: "var(--ink)",
          backdropFilter: "blur(10px)",
          borderBottom: "1px solid rgba(123, 143, 106, 0.25)",
        },
      },
    },
    MuiBottomNavigation: {
      styleOverrides: {
        root: {
          backgroundColor: "rgba(255, 250, 244, 0.94)",
          borderTop: "1px solid rgba(227, 167, 192, 0.35)",
          backdropFilter: "blur(10px)",
        },
      },
    },
    MuiBottomNavigationAction: {
      styleOverrides: {
        root: {
          color: "var(--ink)",
          "&.Mui-selected": {
            color: "var(--sakura-deep)",
          },
        },
      },
    },
  },
});

function App(props) {
  const { window: appWindow } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [noticeOpen, setNoticeOpen] = React.useState(false);
  const [noticeDetailOpen, setNoticeDetailOpen] = React.useState(false);
  const [noticeWriteOpen, setNoticeWriteOpen] = React.useState(false);
  const [notices, setNotices] = React.useState([]);
  const [noticeLoading, setNoticeLoading] = React.useState(true);
  const [noticeError, setNoticeError] = React.useState("");
  const [activeNotice, setActiveNotice] = React.useState(null);
  const [courseOpen, setCourseOpen] = React.useState(false);
  const [activeCourse, setActiveCourse] = React.useState(null);
  const [writeTitle, setWriteTitle] = React.useState("");
  const [writeTag, setWriteTag] = React.useState("News");
  const [writeContent, setWriteContent] = React.useState("");
  const [writePassword, setWritePassword] = React.useState("");
  const [writeImages, setWriteImages] = React.useState([]);
  const [writeImagePreviews, setWriteImagePreviews] = React.useState([]);
  const [writeError, setWriteError] = React.useState("");
  const [writeLoading, setWriteLoading] = React.useState(false);

  const parseNoticeImages = React.useCallback((notice) => {
    const imageValue = notice?.image_url;
    if (!imageValue) {
      return [];
    }

    if (Array.isArray(imageValue)) {
      return imageValue.filter(Boolean);
    }

    if (typeof imageValue !== "string") {
      return [];
    }

    const trimmedValue = imageValue.trim();
    if (!trimmedValue) {
      return [];
    }

    if (trimmedValue.startsWith("[")) {
      try {
        const parsedValue = JSON.parse(trimmedValue);
        return Array.isArray(parsedValue) ? parsedValue.filter(Boolean) : [];
      } catch (error) {
        console.error("Failed to parse notice images", error);
      }
    }

    return [trimmedValue];
  }, []);

  useEffect(() => {
    const scriptSrc = "https://www.instagram.com/embed.js";
    const existingScript = document.querySelector(`script[src="${scriptSrc}"]`);

    const processEmbeds = () => {
      if (typeof window === "undefined") {
        return;
      }
      const instgrm = window.instgrm;
      if (instgrm && instgrm.Embeds && instgrm.Embeds.process) {
        instgrm.Embeds.process();
      }
    };

    if (!existingScript) {
      const script = document.createElement("script");
      script.src = scriptSrc;
      script.async = true;
      script.onload = processEmbeds;
      document.body.appendChild(script);
    } else {
      processEmbeds();
    }
  }, []);

  const fetchNotices = async () => {
    setNoticeLoading(true);
    setNoticeError("");
    const { data, error } = await supabase
      .from("notices")
      .select("id,title,tag,content,image_url,created_at")
      .eq("is_visible", true)
      .order("created_at", { ascending: false });

    if (error) {
      setNoticeError("お知らせの読み込みに失敗しました。");
      setNotices([]);
    } else {
      setNotices(data ?? []);
    }
    setNoticeLoading(false);
  };

  useEffect(() => {
    fetchNotices();
  }, []);

  useEffect(() => {
    const previews = writeImages.map((image) => ({
      file: image,
      url: URL.createObjectURL(image),
    }));

    setWriteImagePreviews(previews);

    return () => {
      previews.forEach((preview) => {
        URL.revokeObjectURL(preview.url);
      });
    };
  }, [writeImages]);

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const handleNoticeOpen = () => {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
    setNoticeOpen(true);
  };

  const handleNoticeClose = () => {
    setNoticeOpen(false);
  };

  const handleNoticeDetailOpen = (notice) => {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
    setNoticeOpen(false);
    setActiveNotice(notice);
    setNoticeDetailOpen(true);
  };

  const handleNoticeDetailClose = () => {
    setNoticeDetailOpen(false);
    setActiveNotice(null);
  };

  const handleNoticeWriteOpen = () => {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
    setWriteError("");
    setNoticeOpen(false);
    setNoticeWriteOpen(true);
  };

  const handleNoticeWriteClose = () => {
    setNoticeWriteOpen(false);
    setWriteError("");
    setWritePassword("");
    setWriteTag("News");
    setWriteImages([]);
  };

  const handleWriteImageChange = (event) => {
    const files = Array.from(event.target.files ?? []);
    if (files.length === 0) {
      return;
    }

    let exceededLimit = false;
    setWriteImages((prevImages) => {
      const nextImages = [...prevImages];

      files.forEach((file) => {
        const duplicate = nextImages.some(
          (image) =>
            image.name === file.name &&
            image.size === file.size &&
            image.lastModified === file.lastModified,
        );

        if (!duplicate && nextImages.length < 5) {
          nextImages.push(file);
        } else if (!duplicate) {
          exceededLimit = true;
        }
      });

      return nextImages;
    });
    setWriteError(
      exceededLimit ? "画像は最大5枚までアップロードできます。" : "",
    );
    event.target.value = "";
  };

  const handleWriteImageRemove = (removeIndex) => {
    setWriteImages((prevImages) =>
      prevImages.filter((_, index) => index !== removeIndex),
    );
  };

  const handleNoticeSubmit = async () => {
    const maxImageSize = 5 * 1024 * 1024;
    const allowedTypes = ["image/jpeg", "image/png", "image/webp"];
    const trimmedTitle = writeTitle.trim();
    const trimmedContent = writeContent.trim();

    if (!trimmedTitle || !trimmedContent) {
      setWriteError("タイトルと内容は必須です。");
      return;
    }
    const trimmedPassword = writePassword.trim();
    if (!trimmedPassword) {
      setWriteError("パスワードを入力してください。");
      return;
    }
    if (writeImages.length > 5) {
      setWriteError("画像は最大5枚までアップロードできます。");
      return;
    }
    for (const image of writeImages) {
      if (!allowedTypes.includes(image.type)) {
        setWriteError("画像は JPG / PNG / WEBP のみアップロードできます。");
        return;
      }
      if (image.size > maxImageSize) {
        setWriteError("各画像サイズは 5MB 以下にしてください。");
        return;
      }
    }

    setWriteLoading(true);
    setWriteError("");
    const formData = new FormData();
    formData.append("password", trimmedPassword);
    formData.append("title", trimmedTitle);
    formData.append("content", trimmedContent);
    formData.append("tag", writeTag.trim() || "News");
    if (writeImages[0]) {
      formData.append("image", writeImages[0]);
    }
    writeImages.forEach((image) => {
      formData.append("images", image);
    });
    const response = await fetch(
      `${process.env.REACT_APP_SUPABASE_URL}/functions/v1/create-notice`,
      {
        method: "POST",
        headers: {
          apikey: process.env.REACT_APP_SUPABASE_ANON_KEY,
          Authorization: `Bearer ${process.env.REACT_APP_SUPABASE_ANON_KEY}`,
        },
        body: formData,
      },
    );
    const responseData = await response.json().catch(() => ({}));

    if (!response.ok) {
      const status = response.status;
      console.error("create-notice error", responseData);
      if (status === 401) {
        setWriteError("パスワードが正しくありません。");
      } else {
        setWriteError(
          "投稿に失敗しました。しばらくしてから再度お試しください。",
        );
      }
      setWriteLoading(false);
      return;
    }

    setWriteTitle("");
    setWriteTag("News");
    setWriteContent("");
    setWritePassword("");
    setWriteImages([]);
    setNoticeWriteOpen(false);
    setWriteLoading(false);
    fetchNotices();
  };

  const handleCourseOpen = (course) => {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
    setActiveCourse(course);
    setCourseOpen(true);
  };

  const handleCourseClose = () => {
    setCourseOpen(false);
    setActiveCourse(null);
  };

  const handleMenuItemClick = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
    setMobileOpen(false);
  };

  const formatNoticeDate = (dateString) => {
    if (!dateString) {
      return "";
    }
    const date = new Date(dateString);
    return date.toLocaleDateString("ja-JP", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  };

  const sectionCardSx = {
    mt: 2,
    p: { xs: 2, md: 3 },
    bgcolor: "var(--paper)",
    borderRadius: 1.5,
    border: "1px solid rgba(227, 167, 192, 0.25)",
    boxShadow: "0 16px 30px rgba(47, 42, 37, 0.12)",
  };

  const sectionTitleSx = {
    fontSize: { xs: "1.7rem", md: "2.4rem" },
    color: "var(--ink)",
    textTransform: "uppercase",
  };

  const dialogCloseButtonSx = {
    border: "1px solid rgba(123, 143, 106, 0.35)",
    borderRadius: 999,
    width: 34,
    height: 34,
    bgcolor: "rgba(255, 250, 244, 0.95)",
    color: "var(--ink)",
    "&:hover": {
      bgcolor: "rgba(241, 198, 216, 0.32)",
    },
  };

  const drawer = (
    <Box sx={{ textAlign: "center", color: "var(--ink)" }}>
      <Typography variant="h6" sx={{ my: 2 }}>
        アトリエMUM
      </Typography>
      <Divider sx={{ borderColor: "rgba(123, 143, 106, 0.3)" }} />
      <List>
        {navItems.map((item) => {
          const sectionId = item.toLowerCase().replace(" ", "-");
          return (
            <ListItem key={item} disablePadding>
              <ListItemButton
                sx={{
                  textAlign: "center",
                  color: "var(--ink)",
                  "&:hover": { bgcolor: "rgba(201, 124, 93, 0.12)" },
                }}
                onClick={() => handleMenuItemClick(sectionId)}
              >
                <ListItemText primary={item} />
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
    </Box>
  );

  const container =
    appWindow !== undefined ? () => appWindow().document.body : undefined;

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <GlobalStyles
        styles={{
          "@keyframes fadeUp": {
            from: { opacity: 0, transform: "translateY(18px)" },
            to: { opacity: 1, transform: "translateY(0)" },
          },
          "@keyframes floatSlow": {
            "0%, 100%": { transform: "translateY(0)" },
            "50%": { transform: "translateY(-12px)" },
          },
          a: { color: "inherit", textDecoration: "none" },
        }}
      />
      <Box
        sx={{
          display: "flex",
          pb: 9,
          minHeight: "100vh",
          background:
            "linear-gradient(180deg, rgba(246,241,233,1) 0%, rgba(241,198,216,0.55) 36%, rgba(255,244,248,1) 100%)",
          position: "relative",
          overflow: "hidden",
          "&::before": {
            content: '""',
            position: "absolute",
            top: "-120px",
            right: "-80px",
            width: { xs: "240px", md: "360px" },
            height: { xs: "240px", md: "360px" },
            background:
              "radial-gradient(circle, rgba(241,198,216,0.5), transparent 70%)",
            filter: "blur(4px)",
            animation: "floatSlow 8s ease-in-out infinite",
            zIndex: 0,
          },
          "&::after": {
            content: '""',
            position: "absolute",
            bottom: "-140px",
            left: "-80px",
            width: { xs: "260px", md: "400px" },
            height: { xs: "260px", md: "400px" },
            background:
              "radial-gradient(circle, rgba(123,143,106,0.18), transparent 70%)",
            filter: "blur(6px)",
            zIndex: 0,
          },
        }}
      >
        <AppBar component="nav" elevation={0}>
          <Toolbar
            sx={{
              py: 0,
              minHeight: { xs: 52, sm: 60 },
              alignItems: "center",
            }}
          >
            <Box
              component="img"
              src={logoTop}
              alt="アトリエMUM"
              sx={{
                mr: "auto",
                height: { xs: 44, sm: 50 },
                maxWidth: { xs: "70%", sm: "60%" },
                width: "auto",
                flexShrink: 0,
                objectFit: "contain",
              }}
            />
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="end"
              onClick={handleDrawerToggle}
            >
              <MenuIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <nav>
          <Drawer
            container={container}
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            anchor="right"
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
            sx={{
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: drawerWidth,
                backgroundColor: "rgba(255, 250, 244, 0.98)",
                backdropFilter: "blur(10px)",
              },
            }}
          >
            {drawer}
          </Drawer>
        </nav>
        <Box
          component="main"
          sx={{
            px: { xs: 2, md: 6, lg: 10 },
            py: { xs: 2, md: 4 },
            flexGrow: 1,
            width: "100%",
          }}
        >
          <Toolbar />
          <Box
            sx={{ maxWidth: 1080, mx: "auto", position: "relative", zIndex: 1 }}
          >
            {navItems.map((item, index) => {
              const sectionId = item.toLowerCase().replace(" ", "-");
              return (
                <Box
                  key={item}
                  id={sectionId}
                  sx={{
                    minHeight: "auto",
                    pt: { xs: 3, md: 5 },
                    pb: { xs: 3, md: 6 },
                    scrollMarginTop: { xs: "56px", sm: "64px" },
                    animation: "fadeUp 0.8s ease both",
                    animationDelay: `${index * 120}ms`,
                  }}
                >
                  <Typography variant="h4" gutterBottom sx={sectionTitleSx}>
                    {item}
                  </Typography>
                  {item === "Home" && (
                    <Box sx={sectionCardSx}>
                      <Box
                        component="img"
                        src={homeLarge}
                        alt="Home Large"
                        sx={{
                          width: "100%",
                          height: "auto",
                          maxHeight: { xs: "none", md: "62vh" },
                          objectFit: "contain",
                          borderRadius: 0,
                          boxShadow: "0 20px 30px rgba(47, 42, 37, 0.18)",
                          filter: "saturate(1.05)",
                        }}
                      />
                      <Box
                        sx={{
                          mt: 1,
                          display: "grid",
                          gridTemplateColumns: "repeat(3, 1fr)",
                          gap: 1,
                        }}
                      >
                        {[homeSmall1, homeSmall2, homeSmall3].map(
                          (src, imageIndex) => (
                            <Box
                              key={src}
                              component="img"
                              src={src}
                              alt={`Home Small ${imageIndex + 1}`}
                              sx={{
                                width: "100%",
                                height: "auto",
                                aspectRatio: { xs: "1 / 1", md: "4 / 3" },
                                objectFit: "cover",
                                borderRadius: 0,
                                boxShadow: "0 12px 20px rgba(47, 42, 37, 0.16)",
                              }}
                            />
                          ),
                        )}
                      </Box>
                    </Box>
                  )}
                  {item === "Information" && (
                    <Box sx={sectionCardSx}>
                      <Box sx={{ display: "grid", gap: 1.5 }}>
                        {noticeLoading && (
                          <Typography
                            variant="body2"
                            sx={{ color: "text.secondary" }}
                          >
                            読み込み中...
                          </Typography>
                        )}
                        {noticeError && (
                          <Typography
                            variant="body2"
                            sx={{ color: "error.main" }}
                          >
                            {noticeError}
                          </Typography>
                        )}
                        {!noticeLoading &&
                          !noticeError &&
                          notices.slice(0, 3).map((notice) => (
                            <Box
                              key={
                                notice.id ??
                                `${notice.title}-${notice.created_at}`
                              }
                              sx={{
                                display: "flex",
                                flexDirection: { xs: "column", sm: "row" },
                                gap: 1,
                                alignItems: { xs: "flex-start", sm: "center" },
                                p: 1.5,
                                borderRadius: 1.5,
                                bgcolor: "rgba(255, 244, 248, 0.8)",
                                border: "1px solid rgba(227, 167, 192, 0.22)",
                                cursor: "pointer",
                                "&:hover": {
                                  bgcolor: "rgba(241, 198, 216, 0.24)",
                                },
                              }}
                              onClick={() => handleNoticeDetailOpen(notice)}
                            >
                              <Typography
                                variant="body2"
                                sx={{ minWidth: 90, color: "text.secondary" }}
                              >
                                {formatNoticeDate(notice.created_at)}
                              </Typography>
                              <Typography variant="body1" sx={{ flexGrow: 1 }}>
                                {notice.title}
                              </Typography>
                              {notice.tag && (
                                <Chip
                                  label={notice.tag}
                                  size="small"
                                  sx={{
                                    bgcolor: "rgba(123, 143, 106, 0.18)",
                                    color: "#3e4a37",
                                  }}
                                />
                              )}
                            </Box>
                          ))}
                      </Box>
                      <Box sx={{ mt: 2, textAlign: "right" }}>
                        <Button
                          variant="text"
                          color="inherit"
                          onClick={handleNoticeOpen}
                        >
                          More
                        </Button>
                      </Box>
                    </Box>
                  )}
                  {item === "プロフィール" && (
                    <Box sx={sectionCardSx}>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: 2,
                          mb: 3,
                        }}
                      >
                        <Box
                          component="img"
                          src={profileImg}
                          alt="Profile"
                          sx={{
                            width: "50%",
                            height: "auto",
                            borderRadius: 1.5,
                            boxShadow: "0 16px 26px rgba(47, 42, 37, 0.18)",
                          }}
                        />
                        <Box
                          sx={{
                            width: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Typography
                            variant="h4"
                            sx={{
                              fontWeight: "bold",
                              color: "var(--sage)",
                              textAlign: "center",
                              fontSize: {
                                xs: "1.15rem",
                                sm: "1.5rem",
                                md: "2.125rem",
                              },
                              lineHeight: 1.2,
                            }}
                          >
                            齋藤真由美（salvia）
                          </Typography>
                        </Box>
                      </Box>
                      <Box>
                        <Typography variant="body1" sx={{ mb: 2 }}>
                          30代の頃にFFDA協会グレースフラワースクールと出会い、フラワーアレンジメントの世界へ。
                        </Typography>
                        <Typography variant="body1" sx={{ mb: 2 }}>
                          フレッシュフラワーをはじめ、ドライフラワー、ブリザーブドフラワー、アーティフィシャルフラワー、ハーバリウム制作などを学び、各種ディプロマを取得。
                        </Typography>
                        <Typography variant="body1" sx={{ mb: 2 }}>
                          埼玉県朝霞市の自宅にアトリエを構え、「花をもっと身近に、日常の中で楽しんでほしい」という想いのもと、講師活動を行っています。
                        </Typography>
                        <Typography variant="body1" sx={{ mb: 2 }}>
                          気軽に参加できる単発レッスンから、ディプロマ取得を目指せるコースレッスンまで幅広く開講し、初めての方から本格的に学びたい方まで、それぞれの目的に合わせたレッスンを大切にしています。
                        </Typography>
                        <Typography variant="body1">
                          私生活では3人の子どもと3人の孫に恵まれ、家族に囲まれた日々を過ごしています。看板犬はミニチュアシュナウザーのマルくんです！
                        </Typography>
                      </Box>
                    </Box>
                  )}
                  {item === "自宅レッスン" && (
                    <Box sx={sectionCardSx}>
                      <Typography variant="body1" sx={{ mb: 2 }}>
                        初心者の方、まずは体験してみたい方、毎回お好みの作品を作りたい方におすすめな単発レッスンから、FFDA認定アトリエを開設できるコース、生花やプリザーブドフラワーのコースなど様々なコースレッスンがございます。
                      </Typography>
                      <Typography variant="body1">
                        自宅でのレッスンですので、大人数が苦手という方も安心してご参加いただけます。
                        <br />
                        お子様連れでのご参加も可能です。
                      </Typography>
                      <Divider
                        sx={{ my: 3, borderColor: "rgba(227, 167, 192, 0.35)" }}
                      />
                      <Box
                        sx={{
                          display: "grid",
                          gridTemplateColumns: {
                            xs: "1fr 1fr",
                            md: "repeat(3, 1fr)",
                          },
                          gap: 2,
                        }}
                      >
                        {[
                          { src: homelessonHerbarium, label: "ハーバリウム" },
                          {
                            src: homelessonDriedflower,
                            label: "ドライフラワーアレンジ",
                          },
                          { src: homelessonFreshflower, label: "生花アレンジ" },
                          { src: homelessonBouquet, label: "ブーケ" },
                          {
                            src: homelessonArtflower,
                            label: "アートフラワーアレンジ",
                          },
                          {
                            src: homelessonPreservedflower,
                            label: "ブリザーブドフラワーアレンジ",
                          },
                        ].map((itemData, itemIndex) => (
                          <Box key={`${itemData.label}-${itemIndex}`}>
                            <Box
                              component="img"
                              src={itemData.src}
                              alt={itemData.label}
                              sx={{
                                width: "100%",
                                height: "auto",
                                aspectRatio: "1 / 1",
                                objectFit: "cover",
                                borderRadius: 1,
                                boxShadow: "0 10px 18px rgba(47, 42, 37, 0.14)",
                              }}
                            />
                            <Typography
                              variant="body2"
                              sx={{ mt: 1, textAlign: "center" }}
                            >
                              {itemData.label}
                            </Typography>
                          </Box>
                        ))}
                      </Box>
                      <Divider
                        sx={{ my: 3, borderColor: "rgba(227, 167, 192, 0.35)" }}
                      />
                      <Typography variant="h5" sx={{ mb: 2 }}>
                        コース紹介
                      </Typography>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: { xs: "column", sm: "row" },
                          gap: 2,
                          alignItems: { xs: "flex-start", sm: "center" },
                          p: 2,
                          bgcolor: "rgba(255, 244, 248, 0.8)",
                          borderRadius: 1.5,
                          border: "1px solid rgba(227, 167, 192, 0.25)",
                        }}
                      >
                        <Box
                          component="img"
                          src={course1}
                          alt="インテリアフラワークリエーターコース"
                          sx={{
                            width: { xs: "100%", sm: 220, md: 260 },
                            height: "auto",
                            aspectRatio: "1 / 1",
                            objectFit: "cover",
                            borderRadius: 1,
                            boxShadow: "0 12px 20px rgba(47, 42, 37, 0.14)",
                          }}
                        />
                        <Box>
                          <Typography variant="h6" sx={{ mb: 1 }}>
                            <Box component="span" sx={{ display: "block" }}>
                              インテリアフラワー
                            </Box>
                            <Box component="span" sx={{ display: "block" }}>
                              クリエーターコース
                            </Box>
                          </Typography>
                          <Chip
                            label="🔰初心者可"
                            size="small"
                            sx={{
                              mb: 1.5,
                              bgcolor: "rgba(123, 143, 106, 0.2)",
                              color: "#3e4a37",
                              fontWeight: 500,
                            }}
                          />
                          <Typography variant="body1">
                            ドライフラワーやプリザーブドフラワー・アートフラワー等様々な花材を使いお部屋を飾るインテリアフラワーを制作するコースです。アレンジメントやリース・壁飾りの他ハーバリウムやスワッグの制作も含まれています。
                            <br />
                            <br />
                            コース終了後はクリエーターとして販売活動や制作活動ができる技術が身に付きます。
                            <br />
                            <br />
                            アトリエ申請するとFFDAのインストラクターとして講師活動が可能です。
                          </Typography>
                          <Box
                            sx={{
                              mt: 2,
                              display: "flex",
                              justifyContent: "flex-end",
                            }}
                          >
                            <Chip
                              label="詳細を見る"
                              clickable
                              onClick={() =>
                                handleCourseOpen({
                                  title:
                                    "インテリアフラワークリエイターコースのレッスン費の詳細",
                                  detail: `BASICクラス（全8単位）

【一括払い】
118,000円
（レッスン費・花材費・認定ディプロマ代・アトリエ申請料込み）

【分割払い】
・1単位：8,500円
（レッスン費・花材費・認定ディプロマ代込み）

※分割払いにはアトリエ申請料は含まれていません。
アトリエ申請をご希望の場合は、別途50,000円が必要です。
ご希望の方は、1単位ごとに6,250円ずつ分割してお支払いいただけます。
※アトリエ申請を行わない場合、FFDAブランチ講師としての活動はできませんのでご注意ください。`,
                                })
                              }
                              sx={{
                                bgcolor: "rgba(240, 215, 195, 0.35)",
                                color: "#6b4d3a",
                                fontWeight: 600,
                                "&:hover": {
                                  bgcolor: "rgba(240, 215, 195, 0.55)",
                                },
                              }}
                            />
                          </Box>
                        </Box>
                      </Box>
                      <Box
                        sx={{
                          mt: 2,
                          display: "flex",
                          flexDirection: { xs: "column", sm: "row" },
                          gap: 2,
                          alignItems: { xs: "flex-start", sm: "center" },
                          p: 2,
                          bgcolor: "rgba(255, 244, 248, 0.8)",
                          borderRadius: 1.5,
                          border: "1px solid rgba(227, 167, 192, 0.25)",
                        }}
                      >
                        <Box
                          component="img"
                          src={course2}
                          alt="BASICアレンジメントクラス"
                          sx={{
                            width: { xs: "100%", sm: 220, md: 260 },
                            height: "auto",
                            aspectRatio: "1 / 1",
                            objectFit: "cover",
                            borderRadius: 1,
                            boxShadow: "0 12px 20px rgba(47, 42, 37, 0.14)",
                          }}
                        />
                        <Box>
                          <Typography variant="h6" sx={{ mb: 1 }}>
                            BASICアレンジメントクラス
                          </Typography>
                          <Chip
                            label="🔰初心者可"
                            size="small"
                            sx={{
                              mb: 1.5,
                              bgcolor: "rgba(123, 143, 106, 0.2)",
                              color: "#3e4a37",
                              fontWeight: 500,
                            }}
                          />
                          <Typography variant="body1">
                            アレンジメントの基礎デザインを学ぶクラス
                            <br />
                            <br />
                            トライアンギュラー・ホリゾンタル・ドームなどトラディッショナルスタイルのデザインパターンをレッスンします。テキストを使って順番に活けていきますのでどなたでも無理なく素敵なデザインが制作できるようになります。
                            <br />
                            <br />
                            母の日・ハロウィン・クリスマス・お正月などの季節の行事も取り入れた花アレンジのレッスンも行っています。
                            <br />
                            <br />
                            ※初回にテキスト代1,500円が必要です
                          </Typography>
                          <Box
                            sx={{
                              mt: 2,
                              display: "flex",
                              justifyContent: "flex-end",
                            }}
                          >
                            <Chip
                              label="詳細を見る"
                              clickable
                              onClick={() =>
                                handleCourseOpen({
                                  title:
                                    "BASICアレンジメントコースのレッスン費の詳細",
                                  detail: `BASICクラス（全24単位）

・1単位レッスン：6,900円（レッスン費・花材費込み）

・全単位修了後、試験あり
　ディプロマ申請料：40,000円

・認定試験合格後、アトリエ開設可能
　開設料：50,000円

・アトリエ開設後、年間ライセンス使用料が必要
　年額：5,000円

・認定試験料・ディプロマ代を24回分割し、
　レッスン料に含めて支払うことも可能
　その場合：1単位 8,700円
　（レッスン費・花材費・認定試験料・ディプロマ代すべて込み）`,
                                })
                              }
                              sx={{
                                bgcolor: "rgba(240, 215, 195, 0.35)",
                                color: "#6b4d3a",
                                fontWeight: 600,
                                "&:hover": {
                                  bgcolor: "rgba(240, 215, 195, 0.55)",
                                },
                              }}
                            />
                          </Box>
                        </Box>
                      </Box>
                      <Box
                        sx={{
                          mt: 2,
                          display: "flex",
                          flexDirection: { xs: "column", sm: "row" },
                          gap: 2,
                          alignItems: { xs: "flex-start", sm: "center" },
                          p: 2,
                          bgcolor: "rgba(255, 244, 248, 0.8)",
                          borderRadius: 1.5,
                          border: "1px solid rgba(227, 167, 192, 0.25)",
                        }}
                      >
                        <Box
                          component="img"
                          src={course4}
                          alt="ADVANCEアレンジメントクラス"
                          sx={{
                            width: { xs: "100%", sm: 220, md: 260 },
                            height: "auto",
                            aspectRatio: "1 / 1",
                            objectFit: "cover",
                            borderRadius: 1,
                            boxShadow: "0 12px 20px rgba(47, 42, 37, 0.14)",
                          }}
                        />
                        <Box>
                          <Typography variant="h6" sx={{ mb: 1 }}>
                            ADVANCEアレンジメントクラス
                          </Typography>
                          <Chip
                            label="BASIC修了者対象"
                            size="small"
                            sx={{
                              mb: 1.5,
                              bgcolor: "rgba(123, 143, 106, 0.2)",
                              color: "#3e4a37",
                              fontWeight: 500,
                            }}
                          />
                          <Typography variant="body1">
                            本クラスでは、オランダ、ドイツ、フランスのデザインを中心に、フラワーアレンジメントの上級テクニックを学びます。
                            <br />
                            デコラスタイルやフェゲタスタイルなど、ヨーロピアンスタイルのデザインを取り入れながら、より表現力のあるアレンジメントを制作していきます。
                            <br />
                            <br />
                            また、通常よりもスケールのあるアレンジメントにも取り組み、葉物や枝物の使い方についても深く学んでいきます。
                            <br />
                            <br />
                            ※本クラスは、BASICアレンジメントクラスのディプロマ取得者を対象としたレッスンです。
                          </Typography>
                          <Box
                            sx={{
                              mt: 2,
                              display: "flex",
                              justifyContent: "flex-end",
                            }}
                          >
                            <Chip
                              label="詳細を見る"
                              clickable
                              onClick={() =>
                                handleCourseOpen({
                                  title:
                                    "ADVANCEアレンジメントコースのレッスン費の詳細",
                                  detail: `・1単位レッスン：7,900円（レッスン費・花材費込み）

・全単位修了後、試験あり
ディプロマ申請料：50,000円`,
                                })
                              }
                              sx={{
                                bgcolor: "rgba(240, 215, 195, 0.35)",
                                color: "#6b4d3a",
                                fontWeight: 600,
                                "&:hover": {
                                  bgcolor: "rgba(240, 215, 195, 0.55)",
                                },
                              }}
                            />
                          </Box>
                        </Box>
                      </Box>
                      <Box
                        sx={{
                          mt: 2,
                          display: "flex",
                          flexDirection: { xs: "column", sm: "row" },
                          gap: 2,
                          alignItems: { xs: "flex-start", sm: "center" },
                          p: 2,
                          bgcolor: "rgba(255, 244, 248, 0.8)",
                          borderRadius: 1.5,
                          border: "1px solid rgba(227, 167, 192, 0.25)",
                        }}
                      >
                        <Box
                          component="img"
                          src={course3}
                          alt="シーズンリース＆スワッグコース"
                          sx={{
                            width: { xs: "100%", sm: 220, md: 260 },
                            height: "auto",
                            aspectRatio: "1 / 1",
                            objectFit: "cover",
                            borderRadius: 1,
                            boxShadow: "0 12px 20px rgba(47, 42, 37, 0.14)",
                          }}
                        />
                        <Box>
                          <Typography variant="h6" sx={{ mb: 1 }}>
                            シーズンリース＆スワッグコース
                          </Typography>
                          <Chip
                            label="🔰初心者可"
                            size="small"
                            sx={{
                              mb: 1.5,
                              bgcolor: "rgba(123, 143, 106, 0.2)",
                              color: "#3e4a37",
                              fontWeight: 500,
                            }}
                          />
                          <Typography variant="body1">
                            旬の生花を使ってリースやスワッグを製作するクラスです。
                            <br />
                            ドライになるまで楽しめます。
                          </Typography>
                          <Box
                            sx={{
                              mt: 2,
                              display: "flex",
                              justifyContent: "flex-end",
                            }}
                          >
                            <Chip
                              label="詳細を見る"
                              clickable
                              onClick={() =>
                                handleCourseOpen({
                                  title:
                                    "シーズンリース＆スワッグコースのレッスン費の詳細",
                                  detail: `全10単位

・1レッスン：6,000円

・全10単位修了後、申請によりディプロマを授与
　ディプロマ申請料：30,000円

・アトリエ開設をご希望の方
　アトリエ申請料：50,000円`,
                                })
                              }
                              sx={{
                                bgcolor: "rgba(240, 215, 195, 0.35)",
                                color: "#6b4d3a",
                                fontWeight: 600,
                                "&:hover": {
                                  bgcolor: "rgba(240, 215, 195, 0.55)",
                                },
                              }}
                            />
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  )}
                  {item === "出張レッスン" && (
                    <Box sx={sectionCardSx}>
                      <Typography variant="body1" sx={{ mb: 2 }}>
                        ご自宅やイベント会場へ講師が出張し、現地にてレッスンを行っております（3名様以上よりご相談承ります）。
                        <br />
                        ご自宅でのレッスンは、幼いお子様がいらっしゃる方にも安心してご参加いただけるため、特におすすめです。
                      </Typography>
                      <Typography variant="body1" sx={{ mb: 2 }}>
                        また、各種マルシェへの出店をはじめ、保育園・学童・デイケアサービスなど、法人様向けの出張ワークショップも承っております。
                        <br />
                        彩り豊かなお花に囲まれながら、作品について語り合い、日常から少し離れた癒しのひとときをお過ごしいただければ幸いです。
                      </Typography>
                      <Typography variant="body1">
                        レッスンの人数や費用につきましては、お問い合わせフォームよりお気軽にご相談ください。
                      </Typography>
                      <Box
                        sx={{
                          mt: 3,
                          display: "grid",
                          gridTemplateColumns: {
                            xs: "repeat(2, 1fr)",
                            sm: "repeat(4, 1fr)",
                          },
                          gap: 1.5,
                        }}
                      >
                        {[
                          onsitelesson1,
                          onsitelesson2,
                          onsitelesson3,
                          onsitelesson4,
                        ].map((src, imageIndex) => (
                          <Box
                            key={`${src}-${imageIndex}`}
                            component="img"
                            src={src}
                            alt={`出張レッスン ${imageIndex + 1}`}
                            sx={{
                              width: "100%",
                              height: "auto",
                              aspectRatio: "1 / 1",
                              objectFit: "cover",
                              borderRadius: 1,
                              boxShadow: "0 10px 18px rgba(47, 42, 37, 0.14)",
                            }}
                          />
                        ))}
                      </Box>
                    </Box>
                  )}
                  {item === "Instagram" && (
                    <Box sx={sectionCardSx}>
                      <Grid
                        container
                        spacing={2}
                        sx={{ justifyContent: "center" }}
                      >
                        <Grid
                          size={{ xs: 12, sm: 6 }}
                          sx={{ display: "flex", justifyContent: "center" }}
                        >
                          <Box
                            sx={{
                              width: "100%",
                              maxWidth: { xs: "100%", sm: 360 },
                              borderRadius: 1.5,
                              overflow: "hidden",
                              boxShadow: "0 12px 20px rgba(47, 42, 37, 0.12)",
                            }}
                          >
                            <blockquote
                              className="instagram-media"
                              data-instgrm-permalink="https://www.instagram.com/p/DRjjT6jklMR/?igsh=b2xoaDczeDh0ODh0"
                              data-instgrm-version="12"
                              style={{
                                maxWidth: "100%",
                                width: "100%",
                                margin: 0,
                              }}
                            ></blockquote>
                          </Box>
                        </Grid>
                        <Grid
                          size={{ xs: 12, sm: 6 }}
                          sx={{ display: "flex", justifyContent: "center" }}
                        >
                          <Box
                            sx={{
                              width: "100%",
                              maxWidth: { xs: "100%", sm: 360 },
                              borderRadius: 1.5,
                              overflow: "hidden",
                              boxShadow: "0 12px 20px rgba(47, 42, 37, 0.12)",
                            }}
                          >
                            <blockquote
                              className="instagram-media"
                              data-instgrm-permalink="https://www.instagram.com/p/DQ1I2LHErdE/?igsh=OHNtaXh5ZXZzYnE0"
                              data-instgrm-version="12"
                              style={{
                                maxWidth: "100%",
                                width: "100%",
                                margin: 0,
                              }}
                            ></blockquote>
                          </Box>
                        </Grid>
                      </Grid>
                    </Box>
                  )}
                  {item === "お問い合わせ" && (
                    <Box sx={{ ...sectionCardSx, textAlign: "center" }}>
                      <Typography variant="body1">
                        <Box
                          component="span"
                          sx={{ display: { xs: "block", sm: "inline" } }}
                        >
                          アトリエMUMへの
                        </Box>
                        <Box
                          component="span"
                          sx={{ display: { xs: "block", sm: "inline" } }}
                        >
                          ご連絡・お問合せ・お仕事のご依頼等は
                        </Box>
                        <br />
                        salvia214@yahoo.co.jpへメール
                        <br />
                        またはInstagramのDMよりお願いいたします。
                        <br />
                        ※内容によっては、ご回答にお時間をいただくこともございます。
                      </Typography>
                    </Box>
                  )}
                  {item === "お問い合わせ" && (
                    <Box sx={{ mt: 2 }}>
                      <Box
                        component="img"
                        src={graceFC}
                        alt="Grace Flower Center"
                        sx={{
                          width: "100%",
                          height: "auto",
                          borderRadius: 1.5,
                          boxShadow: "0 12px 20px rgba(47, 42, 37, 0.12)",
                        }}
                      />
                    </Box>
                  )}
                </Box>
              );
            })}
          </Box>
        </Box>
        <Paper
          sx={{
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: (themeValue) => themeValue.zIndex.appBar + 1,
          }}
          elevation={0}
        >
          <BottomNavigation
            showLabels
            sx={{
              justifyContent: "center",
              "& .MuiBottomNavigationAction-root": {
                flex: "0 1 160px",
                maxWidth: 180,
              },
            }}
          >
            <BottomNavigationAction
              component="a"
              href="https://www.instagram.com/salvia214/"
              target="_blank"
              rel="noopener noreferrer"
              label="Instagram"
              icon={<InstagramIcon />}
            />
            <BottomNavigationAction
              component="a"
              href="mailto:salvia214@yahoo.co.jp"
              label="Mail"
              icon={<MailIcon />}
            />
          </BottomNavigation>
        </Paper>
        <Dialog
          open={noticeOpen}
          onClose={handleNoticeClose}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              fontSize: "1.1rem",
            }}
          >
            Information
            <IconButton
              onClick={handleNoticeClose}
              aria-label="close"
              sx={dialogCloseButtonSx}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ pb: 3 }}>
            <Box sx={{ display: "grid", gap: 1.5 }}>
              {noticeLoading && (
                <Typography variant="body2" sx={{ color: "text.secondary" }}>
                  読み込み中...
                </Typography>
              )}
              {noticeError && (
                <Typography variant="body2" sx={{ color: "error.main" }}>
                  {noticeError}
                </Typography>
              )}
              {!noticeLoading &&
                !noticeError &&
                notices.map((notice) => (
                  <Box
                    key={notice.id ?? `${notice.title}-${notice.created_at}`}
                    sx={{
                      display: "flex",
                      flexDirection: { xs: "column", sm: "row" },
                      gap: 1,
                      alignItems: { xs: "flex-start", sm: "center" },
                      p: 1.5,
                      borderRadius: 1.5,
                      bgcolor: "rgba(255, 244, 248, 0.8)",
                      border: "1px solid rgba(227, 167, 192, 0.22)",
                      cursor: "pointer",
                      "&:hover": {
                        bgcolor: "rgba(241, 198, 216, 0.24)",
                      },
                    }}
                    onClick={() => handleNoticeDetailOpen(notice)}
                  >
                    <Typography
                      variant="body2"
                      sx={{ minWidth: 90, color: "text.secondary" }}
                    >
                      {formatNoticeDate(notice.created_at)}
                    </Typography>
                    <Typography variant="body1" sx={{ flexGrow: 1 }}>
                      {notice.title}
                    </Typography>
                    {notice.tag && (
                      <Chip
                        label={notice.tag}
                        size="small"
                        sx={{
                          bgcolor: "rgba(123, 143, 106, 0.18)",
                          color: "#3e4a37",
                        }}
                      />
                    )}
                  </Box>
                ))}
            </Box>
          </DialogContent>
          <DialogActions sx={{ px: 3, pb: 2 }}>
            <Button
              variant="outlined"
              color="inherit"
              onClick={handleNoticeWriteOpen}
            >
              書き込み
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleNoticeClose}
            >
              閉じる
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={noticeDetailOpen}
          onClose={handleNoticeDetailClose}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              fontSize: "1.1rem",
            }}
          >
            Information
            <IconButton
              onClick={handleNoticeDetailClose}
              aria-label="close"
              sx={dialogCloseButtonSx}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ pb: 3 }}>
            <Divider sx={{ mb: 2, borderColor: "rgba(227, 167, 192, 0.3)" }} />
            {activeNotice ? (
              <Box sx={{ display: "grid", gap: 1.5 }}>
                <Typography variant="body2" sx={{ color: "text.secondary" }}>
                  {formatNoticeDate(activeNotice.created_at)}
                </Typography>
                <Typography variant="h6">{activeNotice.title}</Typography>
                {activeNotice.tag && (
                  <Chip
                    label={activeNotice.tag}
                    size="small"
                    sx={{
                      bgcolor: "rgba(123, 143, 106, 0.18)",
                      color: "#3e4a37",
                      width: "fit-content",
                    }}
                  />
                )}
                <Typography variant="body1" sx={{ whiteSpace: "pre-line" }}>
                  {activeNotice.content}
                </Typography>
                {parseNoticeImages(activeNotice).length > 0 && (
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: {
                        xs: "1fr",
                        sm:
                          parseNoticeImages(activeNotice).length === 1
                            ? "1fr"
                            : "1fr 1fr",
                      },
                      gap: 1.5,
                    }}
                  >
                    {parseNoticeImages(activeNotice).map(
                      (imageUrl, imageIndex) => (
                        <Box
                          key={`${imageUrl}-${imageIndex}`}
                          component="img"
                          src={imageUrl}
                          alt={`${activeNotice.title} ${imageIndex + 1}`}
                          sx={{
                            width: "100%",
                            height: "auto",
                            maxHeight: { xs: "none", sm: 420 },
                            objectFit: "contain",
                            borderRadius: 1,
                            boxShadow: "0 10px 18px rgba(47, 42, 37, 0.16)",
                          }}
                        />
                      ),
                    )}
                  </Box>
                )}
              </Box>
            ) : (
              <Typography variant="body2" sx={{ color: "text.secondary" }}>
                読み込み中...
              </Typography>
            )}
          </DialogContent>
        </Dialog>
        <Dialog
          open={noticeWriteOpen}
          onClose={handleNoticeWriteClose}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              fontSize: "1.1rem",
            }}
          >
            Information 書き込み
            <IconButton
              onClick={handleNoticeWriteClose}
              aria-label="close"
              sx={dialogCloseButtonSx}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ pb: 2, display: "grid", gap: 2 }}>
            <TextField
              label="タイトル"
              value={writeTitle}
              onChange={(event) => setWriteTitle(event.target.value)}
              fullWidth
            />
            <TextField
              label="内容"
              value={writeContent}
              onChange={(event) => setWriteContent(event.target.value)}
              multiline
              minRows={4}
              fullWidth
            />
            <Box>
              <Button variant="outlined" component="label" color="inherit">
                画像を選択
                <input
                  hidden
                  type="file"
                  multiple
                  accept="image/jpeg,image/png,image/webp"
                  onChange={handleWriteImageChange}
                />
              </Button>
              <Typography
                variant="body2"
                sx={{ mt: 1, color: "text.secondary" }}
              >
                {writeImages.length > 0
                  ? `${writeImages.length} / 5枚 選択中`
                  : "未選択（JPG / PNG / WEBP, 最大5枚, 各 5MB）"}
              </Typography>
              {writeImagePreviews.length > 0 && (
                <Box sx={{ mt: 1.5, display: "grid", gap: 1, minWidth: 0 }}>
                  {writeImagePreviews.map((preview, index) => (
                    <Box
                      key={`${preview.file.name}-${preview.file.lastModified}-${index}`}
                      sx={{
                        display: "flex",
                        minWidth: 0,
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: 1,
                        px: 1.25,
                        py: 1.25,
                        borderRadius: 1,
                        bgcolor: "rgba(255, 244, 248, 0.8)",
                        border: "1px solid rgba(227, 167, 192, 0.22)",
                      }}
                    >
                      <Box
                        component="img"
                        src={preview.url}
                        alt={preview.file.name}
                        sx={{
                          width: 56,
                          height: 56,
                          flexShrink: 0,
                          objectFit: "cover",
                          borderRadius: 1,
                          boxShadow: "0 6px 12px rgba(47, 42, 37, 0.12)",
                        }}
                      />
                      <Box
                        sx={{
                          flex: 1,
                          minWidth: 0,
                        }}
                      >
                        <Typography
                          variant="body2"
                          noWrap
                          sx={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {index + 1}. {preview.file.name}
                        </Typography>
                      </Box>
                      <IconButton
                        size="small"
                        aria-label={`remove ${preview.file.name}`}
                        onClick={() => handleWriteImageRemove(index)}
                        sx={{ color: "var(--ink)" }}
                      >
                        <CloseIcon fontSize="small" />
                      </IconButton>
                    </Box>
                  ))}
                </Box>
              )}
            </Box>
            <TextField
              label="パスワード"
              type="password"
              value={writePassword}
              onChange={(event) => setWritePassword(event.target.value)}
              fullWidth
            />
            {writeError && (
              <Typography variant="body2" sx={{ color: "error.main" }}>
                {writeError}
              </Typography>
            )}
          </DialogContent>
          <DialogActions sx={{ px: 3, pb: 2 }}>
            <Button
              variant="outlined"
              color="inherit"
              onClick={handleNoticeWriteClose}
            >
              キャンセル
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleNoticeSubmit}
              disabled={writeLoading}
            >
              {writeLoading ? "送信中..." : "投稿"}
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={courseOpen}
          onClose={handleCourseClose}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              fontSize: "1.1rem",
            }}
          >
            {activeCourse?.title ?? "コース詳細"}
            <IconButton
              onClick={handleCourseClose}
              aria-label="close"
              sx={dialogCloseButtonSx}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ pb: 3 }}>
            <Divider sx={{ mb: 2, borderColor: "rgba(227, 167, 192, 0.3)" }} />
            <Typography variant="body1" sx={{ whiteSpace: "pre-line" }}>
              {activeCourse?.detail ?? ""}
            </Typography>
          </DialogContent>
        </Dialog>
      </Box>
    </ThemeProvider>
  );
}

export default App;
